import { Button } from "@mantine/core";
import React from "react";
import { BsTrash } from "react-icons/bs";
import { HiBan } from "react-icons/hi";
import { MdOutlineMessage } from "react-icons/md";
import { useDispatch } from "react-redux";
import { deleteUser } from "../../redux/actions/frontendActions/authenticationAction";
function DashboardUserCard({ user, index }) {

  const dispatch = useDispatch();
  return (
    <div className="dashbaord_message-card dashboard-user-card" key={index}>
      <div className="top">
        <div>
        
          <img src={user.image} alt="" />
        </div>
        <div className="delete">
          <BsTrash  onClick={()=> dispatch(deleteUser(user._id))} />
        </div>
      </div>

      <div className="text-area">
        <div className="email">
          <p>Name</p>
          <h2>
            {user.firstName} {user.lastName}
          </h2>
        </div>

        <div className="email">
          <p>email</p>
          <h6>{user.email}</h6>
        </div>

        <div className="email">
          <p>mobile </p>
          <h6>{user.phone}</h6>
        </div>
        <div className="email">
          <p>Location </p>
          <h6>-</h6>
        </div>
        <div className="email">
          <p>Divice </p>
          <h6>-</h6>
        </div>
        <div className="email">
          <p>Registerd Time </p>
          <h6>{user.updatedAt}</h6>
        </div>
        <div className="button-area-flex">
          <div>
            <a href={`mailto:${user.email}`}>
              <Button
                leftIcon={<MdOutlineMessage />}
                variant="outline"
                color="teal"
              >
                Message
              </Button>
            </a>
          </div>

          <div>
            <Button leftIcon={<HiBan />} variant="outline" color="red">
              Block
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardUserCard;
